// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sHfH0","no-contacts":"styles_no-contacts__A-8kI","card":"styles_card__SyrD5","loader":"styles_loader__rc-au"};